// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from '@/menu-items';

// подтвержденный пользователь
import { useAuth } from '@/auth/AuthContext';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { isVerified, hasMedCard, role } = useAuth();
  const navGroups = menuItem.items
  .filter((elem) => {
    // скрываем пункты по конфигу проекта
    if (elem.visible === false) return false;

    // скрываем restricted для неподтверждённых
    if (elem.restricted && !isVerified) return false;

    // Доработка 25. Разделы по медкарте - пока нет ни одной доступной карты (своей либо
    // члена семьи). Отдельно от restricted: подтверждённая регистрация тут не при чём.
    if (elem.requiresMedCard && !hasMedCard) return false;

    // скрываем admin-раздел для не-админов
    if (elem.id === 'admin' && role !== 'ADMIN') return false;
    
    return true;
  })
  .map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Fix - Navigation Group
            </Typography>
          );
      }
  });
  return <Box>{navGroups}</Box>;
}
